export default {
  title_one: 'Eliminar {{count}} modificadores?',
  title_other: 'Eliminar {{count}} modificadores?',
  description: '<strong>{{items}}</strong> serão removidos do menu',
  buttons: {
    yes: 'Sim',
    no: 'Não',
  },
  toasts: {
    failed_to_delete_modifier_one: 'Falha ao eliminar o modificador',
    failed_to_delete_modifier_other: 'Falha ao eliminar os modificadores',
    modifiers_got_deleted_one: 'Modificador eliminado',
    modifiers_got_deleted_other: 'Modificadores eliminados',
  },
};
